import React from 'react';

import { ResponsivePaymentsTable } from './PaymentsOverviewTable.component';
import { completedPaymentsDesktopColumns } from './PaymentsOverviewTable.declaration-desktop';
import { completedPaymentsOverviewMobileColumns } from './PaymentsOverviewTable.declaration-mobile';
import { Box, Typography } from '@mui/material';
import { useOnScreenObserver } from '@uplift/ui-v2';
import { PatientServiceItem } from '@uplift/api';


export const CompletedPaymentsTable: React.VFC<{
  items: PatientServiceItem[];
}> = ({ items: _completedItems }) => {
  const [ itemsCount, setItemsCount ] = React.useState(10);
  const screenObserverRef = useOnScreenObserver(() => {
    if (itemsCount >= _completedItems.length) return;

    setItemsCount(itemsCount + 10);
  });

  const completedItems = React.useMemo(() => {
    return _completedItems.slice(0, itemsCount) ?? [];
  }, [ _completedItems, itemsCount ]);

  if (!_completedItems.length) {
    return null;
  }

  return (
    <Box display="flex" flexDirection="column" gap="8px">
      <Box px={{ xs: 2, sm: 0 }}>
        <Typography variant="h4">Completed ({_completedItems.length})</Typography>
      </Box>
      <ResponsivePaymentsTable
        columns={{
          desktop: completedPaymentsDesktopColumns,
          mobile: completedPaymentsOverviewMobileColumns,
        }}
        rows={completedItems}
      />
      {_completedItems && itemsCount < _completedItems.length && <div ref={screenObserverRef} />}
    </Box>
  );
};
